<template>
  <section class="dp-layout screen-device-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
    </section>
    <section class="dp-right">
      <div v-if="!schoolId" class="no-data-tip">
        <i class="el-icon-school"></i>
        <p>请从左侧选择学校后再进行大屏设备管理</p>
      </div>
      <div v-else class="content-wrapper">
        <el-card>
          <div slot="header" class="device-card-header">
            <span class="device-card-title">大屏设备管理</span>
            <span v-if="schoolName" class="school-tag">当前学校：{{ schoolName }}</span>
          </div>
          <div class="toolbar-filter-bar">
          <el-form :inline="true" class="toolbar-filter-form">
            <div class="toolbar-filter-fields">
            <el-form-item label="设备名称">
              <el-input v-model="filters.deviceName" placeholder="设备名称" clearable class="toolbar-field-w-xl" />
            </el-form-item>
            <el-form-item label="SN">
              <el-input v-model="filters.sn" placeholder="SN" clearable class="toolbar-field-w-xl" />
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="filters.isEnabled" clearable placeholder="全部" class="toolbar-field-w-sm">
                <el-option label="启用" :value="true" />
                <el-option label="停用" :value="false" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="loadData">查询</el-button>
            </el-form-item>
            </div>
            <div class="toolbar-filter-actions">
              <el-button size="small" type="info" icon="el-icon-refresh-left" @click="resetFilters">重置</el-button>
              <el-button size="small" type="success" icon="el-icon-plus" @click="openEdit()">新增设备</el-button>
            </div>
          </el-form>
          </div>
          <div class="tbl-scroll-host">
            <el-table :data="rows" v-loading="loading" height="100%" style="width: 100%">
            <el-table-column prop="Sn" label="SN" />
            <el-table-column prop="DeviceName" label="名称" />
            <el-table-column prop="Description" label="描述" />
            <el-table-column prop="LocationAddress" label="地址" />
            <el-table-column prop="EventTag" label="事件标签" />
            <el-table-column prop="ConfigVersion" label="版本号" />
            <el-table-column label="状态">
              <template slot-scope="scope">
                <div class="status-cell">
                  <el-switch
                    :value="!!scope.row.IsEnabled"
                    :active-color="'#2563eb'"
                    :inactive-color="'#C0C4CC'"
                    @change="(value) => handleToggleEnabled(scope.row, value)"
                  />
                  <span class="status-text" :class="{ enabled: !!scope.row.IsEnabled }">
                    {{ scope.row.IsEnabled ? "启用" : "停用" }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <div class="table-op-pair">
                  <el-button type="text" size="small" class="table-op-link" @click="openEdit(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" class="table-op-link table-op-link--danger" @click="remove(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
            </el-table>
          </div>
          <div class="pager-bar">
            <el-pagination
              layout="total, prev, pager, next, jumper"
              :current-page="pager.page"
              :page-size="pager.pageSize"
              :total="pager.dataCount"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-card>
      </div>

      <el-dialog :title="form.Id ? '编辑设备' : '新增设备'" :visible.sync="dialogVisible" :width="deviceDialogWidth">
        <el-form :model="form" :rules="formRules" ref="deviceForm" label-width="90px">
          <el-form-item label="SN" prop="Sn">
            <el-input v-model="form.Sn" placeholder="请输入设备SN，例如：SN-10001" />
          </el-form-item>
          <el-form-item label="名称" prop="DeviceName">
            <el-input v-model="form.DeviceName" placeholder="请输入设备名称" />
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="form.Description" type="textarea" :rows="2" placeholder="请输入设备描述（选填）" />
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="form.LocationAddress" placeholder="请输入设备所在地址（选填）" />
          </el-form-item>
          <el-form-item label="事件标签">
            <el-input v-model="form.EventTag" placeholder="例如：德育 / 考勤 / 放学 / 宿舍（选填）" />
          </el-form-item>
          <el-form-item label="启用">
            <el-switch v-model="form.IsEnabled" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { getScreenDeviceList, saveScreenDevice, deleteScreenDevice, setScreenDeviceEnabled } from '../../api/modules/integration';
import DepartmentPane from "@/components/DepartmentPane.vue";

export default {
  name: "ScreenDeviceManageDeviceManage",
  components: { DepartmentPane },
  data() {
    return {
      schoolId: 0,
      schoolName: "",
      loading: false,
      rows: [],
      pager: {
        page: 1,
        pageSize: 10,
        dataCount: 0
      },
      filters: {
        deviceName: "",
        sn: "",
        isEnabled: null
      },
      formRules: {
        Sn: [{ required: true, message: "请输入设备SN", trigger: "blur" }],
        DeviceName: [{ required: true, message: "请输入设备名称", trigger: "blur" }]
      },
      dialogVisible: false,
      form: this.getEmptyForm(),
      layoutViewportWidth: typeof window !== "undefined" ? window.innerWidth : 1200
    };
  },
  computed: {
    deviceDialogWidth() {
      return this.layoutViewportWidth <= 600 ? "96%" : "560px";
    }
  },
  mounted() {
    this.loadData();
    this._onLayoutResize = this.debounceLayoutResize(() => {
      this.layoutViewportWidth = window.innerWidth;
    }, 120);
    window.addEventListener("resize", this._onLayoutResize, { passive: true });
  },
  beforeDestroy() {
    if (this._onLayoutResize) {
      window.removeEventListener("resize", this._onLayoutResize);
    }
  },
  methods: {
    debounceLayoutResize(fn, delay) {
      let timer = null;
      return function wrapped() {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          timer = null;
          fn();
        }, delay);
      };
    },
    getEmptyForm() {
      return {
        Id: 0,
        SchoolId: this.schoolId || 0,
        Sn: "",
        DeviceName: "",
        Description: "",
        LocationAddress: "",
        EventTag: "",
        IsEnabled: true
      };
    },
    async loadData() {
      if (!this.schoolId) {
        this.rows = [];
        return;
      }
      this.loading = true;
      try {
        const res = await getScreenDeviceList({
          ...this.filters,
          schoolId: this.schoolId,
          page: this.pager.page,
          pageSize: this.pager.pageSize
        });
        if (res.data.success) {
          const pageResult = res.data.response || {};
          this.rows = pageResult.data || [];
          this.pager.dataCount = pageResult.dataCount || 0;
          this.pager.page = pageResult.page || this.pager.page;
          this.pager.pageSize = pageResult.PageSize || this.pager.pageSize;
        } else {
          this.$message.error(res.data.msg || "加载失败");
        }
      } finally {
        this.loading = false;
      }
    },
    resetFilters() {
      this.filters = { deviceName: "", sn: "", isEnabled: null };
      this.pager.page = 1;
      this.loadData();
    },
    treeNodeClick(node) {
      this.schoolId = Number(node && node.value ? node.value : 0);
      this.schoolName = node && node.label ? node.label : "";
      this.pager.page = 1;
      this.loadData();
    },
    openEdit(row) {
      if (!this.schoolId) {
        this.$message.warning("请先在左侧选择学校");
        return;
      }
      this.form = row
        ? {
            Id: row.Id || 0,
            SchoolId: row.SchoolId || this.schoolId,
            Sn: row.Sn || "",
            DeviceName: row.DeviceName || "",
            Description: row.Description || "",
            LocationAddress: row.LocationAddress || "",
            EventTag: row.EventTag || "",
            IsEnabled: !!row.IsEnabled
          }
        : this.getEmptyForm();
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.deviceForm) {
          this.$refs.deviceForm.clearValidate();
        }
      });
    },
    async save() {
      this.$refs.deviceForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const res = await saveScreenDevice(this.form);
        if (res.data.success) {
          this.$message.success(res.data.msg || "保存成功");
          this.dialogVisible = false;
          this.pager.page = 1;
          this.loadData();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    async remove(row) {
      await this.$confirm(`确认删除设备 ${row.Sn} 吗？`, "提示");
      const res = await deleteScreenDevice({ id: row.Id });
      if (res.data.success) {
        this.$message.success("删除成功");
        this.loadData();
      } else {
        this.$message.error(res.data.msg || "删除失败");
      }
    },
    async handleToggleEnabled(row, targetEnabled) {
      const oldEnabled = !!row.IsEnabled;
      row.IsEnabled = !!targetEnabled;
      try {
        await this.$confirm(
          `确认将设备 ${row.Sn} ${targetEnabled ? "启用" : "停用"}吗？`,
          "提示",
          {
            type: "warning",
            confirmButtonText: "确认",
            cancelButtonText: "取消"
          }
        );
      } catch (e) {
        row.IsEnabled = oldEnabled;
        return;
      }

      try {
        const res = await setScreenDeviceEnabled({
          id: row.Id,
          isEnabled: !!targetEnabled
        });
        if (res.data.success) {
          this.$message.success(res.data.msg || "状态更新成功");
        } else {
          row.IsEnabled = oldEnabled;
          this.$message.error(res.data.msg || "状态更新失败");
        }
      } catch (e) {
        row.IsEnabled = oldEnabled;
        this.$message.error("状态更新失败");
      }
    },
    handleCurrentChange(page) {
      this.pager.page = page;
      this.loadData();
    }
  }
};
</script>

<style lang="stylus" scoped>
.screen-device-page.dp-layout
  height 100%
  box-sizing border-box
  @media (max-width: 768px)
    flex 1
    min-height 0
    flex-direction column
    align-items stretch
    padding 16px
    .dp-left
      width 100% !important
      max-width 100%
      margin-right 0 !important
      margin-bottom 16px
      max-height 280px
      flex-shrink 0
    .dp-right
      width 100%
      min-width 0 !important
      flex 1
      min-height 0
.screen-device-page .dp-right
  display flex
  flex-direction column
  min-width 0
  min-height 0
  overflow hidden
.screen-device-page .dp-right > .content-wrapper
  flex 1
  min-height 0
  overflow hidden
  display flex
  flex-direction column
  gap 12px
  width 100%
  max-width 100%
  box-sizing border-box
  >>> .el-card
    flex 1
    min-width 0
    min-height 0
    width 100%
    display flex
    flex-direction column
    overflow hidden
    box-sizing border-box
  >>> .el-card__header
    flex-shrink 0
  >>> .el-card__body
    flex 1
    min-width 0
    min-height 0
    overflow hidden
    display flex
    flex-direction column
.tbl-scroll-host
  flex 1 1 auto
  min-height 0
  height 0
  width 100%
  overflow hidden
.pager-bar
  flex-shrink 0
  margin-top 12px
  display flex
  justify-content flex-end
  flex-wrap wrap
  gap 8px
  width 100%
.device-card-header
  display flex
  align-items center
  flex-wrap wrap
  gap 8px 12px
  min-width 0
.device-card-title
  font-size 16px
  font-weight 600
  color #303133
  flex-shrink 0
.no-data-tip
  flex 1
  display flex
  flex-direction column
  align-items center
  justify-content center
  color #c0c4cc
  i
    font-size 48px
    margin-bottom 12px
.school-tag
  margin-left 0
  font-size 12px
  color #909399
  flex-shrink 1
  min-width 0
  overflow hidden
  text-overflow ellipsis
  white-space nowrap


@media (max-width: 768px)
  .screen-device-page .dp-right > .content-wrapper
    overflow visible
    height auto
  .tbl-scroll-host
    height auto
    flex none
    overflow visible

.status-cell
  display inline-flex
  align-items center
  gap 8px
  min-width 84px

.status-text
  font-size 12px
  color #909399
  &.enabled
    color #2563eb
</style>

